import { AssignIncompleteGradPlansStepCtrl } from './assign-incomplete-grad-plans.controller';

export const AssignIncompleteGradPlansStepComponent = {
  controller: AssignIncompleteGradPlansStepCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./assign-incomplete-grad-plans.html'),
};
